<div class='text-center'>

  <div class='checkmark centered'></div>
  <h3>Happy Interneting is just around the corner</h3>

  <p>
    Keep an eye out for Starry around your building. As soon as we're ready to take names off the waitlist, we'll let you know.
  </p>
</div>
